import axios from 'axios'

import store from '@/stores'

import MensagemServico from './MensagemServico'

const URL = process.env.VUE_APP_API_URL
const mensagemServico = new MensagemServico()

/**
 * Abstração para um serviço CRUD genérico, utiliza a API do axios para executar cada um desses métodos.
 * A URL da API é obtida de acordo com o ambiente assim como 'e devolvida pelo webpack.
 */
class Servico {
  /**
   * Construtor padrão que leva como parâmetro o restante da URL, mas sem levar em conta o método.
   * @param {*} path
   */
  constructor(path) {
    this.path = path
  }

  criar(dados) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}`, dados)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperar(id) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${id}`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarTodos(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}`, { params: { ...filtro } })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  total(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/total`, {
        params: { ...filtro },
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  atualizar(id, dados) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${id}`, dados)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  remover(id) {
    store.setCarregando()
    return axios
      .delete(`${URL}/${this.path}/${id}`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  verificarErro(err, exibeMensagem = false) {
    let erro = {
      title: '',
      content: '',
    }

    if (err.response) {
      if (err.response.status === 401) {
        erro = {
          title: 'Erro',
          content: 'A sessão expirou, faça login novamente.',
        }
      } else {
        erro = {
          title: `${err.response.status} - ${err.response.data.msg}`,
          content: err.response.data.err,
        }
      }
    } else if (err.request) {
      erro = {
        title: 'Erro',
        content:
          'A requisição não foi entregue ao servidor, pois o recurso solicitado está indiponível.',
      }
    } else {
      erro = { title: 'Erro', content: 'Requisição inválida.' }
    }

    if (exibeMensagem) {
      mensagemServico.alerta(erro.content, erro.title)
    }

    return { erro }
  }
}

export default Servico
